import { ethers } from "ethers";
import Web3 from "web3";
import { Web3Auth } from "@web3auth/modal";
import environmentVariables from "../config/environmentVariables.js";
import { WALLET_ADAPTERS, CHAIN_NAMESPACES } from "@web3auth/base";
import {
  mldStakingAbi,
  mldStakingAddress,
  mldTokenAddress,
  usdtTokenAddress,
  mldTokenABI,
  lordTokenAddress,
  lordTokenABI,
  nftStakingAddress,
  nftStakingABI,
  metalordNFTManagerAddress,
  metalordNFTManagerABI,
  metaspaceNFTMarketplaceAddress,
  metaspaceNFTMarketplaceABI,
  usdtTokenABI,
} from "./data.js";

const clientId = environmentVariables?.clientId;

export const init = async () => {
  try {
    const web3auth = new Web3Auth({
      clientId: clientId,
      web3AuthNetwork: "aqua", // mainnet, aqua, celeste, cyan or testnet
      chainConfig: {
        chainNamespace: CHAIN_NAMESPACES.EIP155,
        rpcTarget: "https://polygon-mainnet.infura.io/v3/a8460c2c0aca48fa96e428d41e7cd71e",
        blockExplorer: "https://polygonscan.com/",
        chainId: "0x89",
        displayName: "Polygon Mainnet",
        ticker: "matic",
        tickerName: "Matic",
      },
      uiConfig: {
        theme: "dark",
        loginMethodsOrder: ["facebook", "google"],
        appLogo: "https://web3auth.io/images/w3a-L-Favicon-1.svg", // Your App Logo Here
      },
    });

    await web3auth.initModal({
      modalConfig: {
        [WALLET_ADAPTERS.OPENLOGIN]: {
          label: "openlogin",
          loginMethods: {
            google: {
              name: "google login",
              logoDark: "url to your custom logo which will shown in dark mode",
            },
            facebook: {
              // it will hide the facebook option from the Web3Auth modal.
              showOnModal: false,
            },
          },
          // setting it to false will hide all social login methods from modal.
          showOnModal: true,
        },
      },
    });

    const web3authProvider = await web3auth.connect();

    const userInfo=await web3auth.getUserInfo();
    const provider = new ethers.providers.Web3Provider(web3authProvider);
    const signer = provider.getSigner();
    console.log(
      web3authProvider,
      signer.getPrivateKey,
      "web3authproviderprive"
    );
    const address = await signer.getAddress();
    const idToken=await web3auth.authenticateUser();
    
    
    // console.log(idToken,web3authProvider,userInfo,address,';;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;')

    const mldStakingContract = new ethers.Contract(
      mldStakingAddress,
      mldStakingAbi,
      signer
    );
    const mldTokenContract = new ethers.Contract(
      mldTokenAddress,
      mldTokenABI,
      signer
    );
    const usdtTokenContract = new ethers.Contract(
      usdtTokenAddress,
      mldTokenABI,
      signer
    );
    const lordTokenContract = new ethers.Contract(
      lordTokenAddress,
      lordTokenABI,
      signer
    );
    const nftStakingContract = new ethers.Contract(
      nftStakingAddress,
      nftStakingABI,
      signer
    );
    const metalordNFTManagerContract = new ethers.Contract(
      metalordNFTManagerAddress,
      metalordNFTManagerABI,
      signer
    );
    const metaspaceNFTMarketplaceContract = new ethers.Contract(
      metaspaceNFTMarketplaceAddress,
      metaspaceNFTMarketplaceABI,
      signer
    );

    const mldBal = await balanceOf(mldTokenContract, address);
    const lordBal = await balanceOf(lordTokenContract, address);
    const usdtBal = await balanceOf(usdtTokenContract, address);
    const maticBal = await getBalance(provider, address);
    const mldAllowance = await checkAllowance(
      mldTokenContract,
      address,
      mldStakingAddress
    );
    const usdtAllowance = await checkAllowance(
      usdtTokenContract,
      address,
      mldStakingAddress
    );
    const mldMarketPlaceAllowance = await checkAllowance(
      mldTokenContract,
      address,
      metaspaceNFTMarketplaceAddress
    );
    const usdtMarketPlaceAllowance = await checkAllowance(
      usdtTokenContract,
      address,
      metaspaceNFTMarketplaceAddress
    );

    const logout = async () => {
      return await web3auth.logout();
    };

    return {
      provider,
      signer,
      address,
      mldBal,
      mldAllowance,
      mldMarketPlaceAllowance,
      usdtMarketPlaceAllowance,
      usdtBal,
      usdtAllowance,
      maticBal,
      lordBal,
      metalordNFTManagerContract,
      metaspaceNFTMarketplaceContract,
      mldStakingContract,
      mldTokenContract,
      usdtTokenContract,
      lordTokenContract,
      nftStakingContract,
      userInfo,
      idToken,
      logout,
    };
  } catch (error) {
    console.error(error);
    return false;
  }
};

// export const OwnershipTransferred=async (prevadd,newadd)=>{
//   return await lordTokenContract.OwnershipTransferred(prevadd,newadd);
// }

export const transferOwnership = async (nftmarket, userAddress) => {
  return await nftmarket.transferOwnership(userAddress);
};

export const balanceOf = async (lordTokenContract, userAddress) => {
  return await lordTokenContract.balanceOf(userAddress);
};

export const getBalance = async (provider, userAddress) => {
  return await provider.getBalance(userAddress);
};

export const sendToken = async (lordTokenContract, userAddress, amount) => {
  const tx = await lordTokenContract.transfer(userAddress, amount);
  const rec = await tx.wait();
  return rec;
};


export const gasEstimate = async (
  contract,
  userAddress,
  amount,
  currencyName
) => {
  try {
    const web3 = new Web3(
      "https://polygon-mainnet.infura.io/v3/a8460c2c0aca48fa96e428d41e7cd71e"
    );
    let tokenAddress;
    let tokenABI;

    if (currencyName == "MLD") {
      tokenABI = mldTokenABI;
      tokenAddress = mldTokenAddress;
    } else if (currencyName == "LORD") {
      tokenABI = lordTokenABI;
      tokenAddress = lordTokenAddress;
    } else if (currencyName == "USDT") {
      tokenABI = usdtTokenABI;
      tokenAddress = usdtTokenAddress;
    }
    // const gasPrice = await contract?.provider.getGasPrice();
    // console.log(
    //   parseFloat(BigInt(gasPrice) / 1000000000000000000n),
    //   "----------------------------------------"
    // );
    // const gasFees = await contract?.mldTokenContract.methods
    //   .transfer(userAddress, amount)
    //   .estimateGas({ from: contract?.address });
    // console.log(gasFees, "---------------------------------------------");
    // if (gasPrice !== undefined && gasFees !== undefined) {
    //   const gasPriceEther = parseFloat(
    //     ethers.utils.formatUnits(gasPrice, "ether")
    //   );
    //   const totalGasCostEther = gasPriceEther * gasFees;

    //   return totalGasCostEther;
    // } else {
    //   // Handle the case where gas price or gas fees are undefined
    //   throw new Error("Gas price or gas fees are undefined");
    // }
    const tokenContract = new web3.eth.Contract(tokenABI, tokenAddress);

    ///////////////////////////////////// start Recive Notification ///////////////////////////////

    //  function handleTransaction(transaction) {
    //   console.log('Received transaction:');
    //   console.log('Transaction hash:', transaction.hash);
    //   console.log('From:', transaction.from);
    //   console.log('To:', transaction.to);
    //   console.log('Value (wei):', transaction.value.toString());
    // }

    // contract.events.Transfer({ filter: {}, fromBlock: 'latest' })
    //   .on('data', (event) => {
    //     console.log('Incoming Transaction:', event);
    //   })
    //   .on('error', (error) => {
    //     console.error('getting transaction Error Incoming Transaction:', error);
    //   });

    //////////////////////////////////// End Recive Notification ////////////////////////////

    const data = tokenContract?.methods
      .transfer(userAddress, amount)
      .encodeABI();
    const gasPrice = await web3.eth.getGasPrice();
    const transactionObject = {
      from: contract?.address,
      to: tokenAddress,
      data: data,
    };
    const gasEstimate = await web3.eth.estimateGas(transactionObject);
    const gasprice = parseFloat((gasPrice * gasEstimate) / 1e18);
    return gasprice;
    // .then(async (gasEstimate) => {
    //   const gasprice = parseFloat((gasPrice * gasEstimate) / 1e18);
    //   return gasprice;
    // })
    // .catch((err) => {
    //   throw new Error("undefined values");
    // });
  } catch (err) {
    console.log(err, "error");
  }
};
export const checkAllowance = async (
  lordTokenContract,
  userAddress,
  spender
) => {
  return await lordTokenContract.allowance(userAddress, spender);
};

export const approve = async (contract, spender) => {
  const tx = await contract.approve(
    spender,
    BigInt("115792089237316195423570985008687907853269984665640564039457")
  );
  const rec = await tx.wait();
  return rec;
};
